import { render, staticRenderFns } from "./index.vue?vue&type=template&id=89e4c1c6&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e4c1c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89e4c1c6')) {
      api.createRecord('89e4c1c6', component.options)
    } else {
      api.reload('89e4c1c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=89e4c1c6&scoped=true&", function () {
      api.rerender('89e4c1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/index.vue"
export default component.exports